// The canonical markdown lives in the repo-root docs/ folder so the weekly
// docs-sync workflow can publish it to the public docs site; the
// `@axilon-apps/docs/*` alias lives in tsconfig.base.json.
// eslint-disable-next-line @nx/enforce-module-boundaries
import content from '@axilon-apps/docs/privacy-policy.md?raw'
import MarkdownDocPage from '../../components/MarkdownDocPage/MarkdownDocPage'
import { legalDocHref } from './legal-doc-href'

const PrivacyPolicyPage = () => (
  <MarkdownDocPage
    title="Privacy Policy"
    subtitle="How Atbash Labs collects, uses, and protects information."
    content={content}
    transformHref={legalDocHref}
  />
)

export default PrivacyPolicyPage
